"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (liveExperimentGoalKeys) => {
    return Math.floor(Math.random() * liveExperimentGoalKeys.length);
};
//# sourceMappingURL=getExperimentGoalChoice.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/getExperimentGoalChoice.js
// module id = bnAe
// module chunks = 69